import { WizardSmsVerificationStep } from "../../wizard/common-steps/sms-verification-step/wizard-sms-verification-step";
import { getConfiguration, goToThankYouPage, ThankYouPageWizardKind } from "../../../utils/configuration";
import { verifyNotaryEstimationPhone } from "../../../api/notary-estimation/verify-notary-estimation-phone";
import { USER_DATA_ID } from "../custom-data";
import { NotaryEstimationWizard } from "../notary-estimation-wizard";

export class NotaryEstimationWizardStep03Sms extends WizardSmsVerificationStep<NotaryEstimationWizard> {
	protected async processVerification(code: string): Promise<boolean> {
		const id = this.snapshotState.getRequiredCustomData<string>(USER_DATA_ID);
		return await verifyNotaryEstimationPhone(id, code);
	}

	protected override afterSuccessfulVerification(): void {
		dataLayer.push({
			event: "lead_notary",
			language_code: getConfiguration().languageCode,
		});

		goToThankYouPage({
			wizard: ThankYouPageWizardKind.Notary,
		});
	}
}
